<template>
  <div class="info d-flex align-center justify-center">
    <div class="info-content d-flex f-column align-center">
      <h3>溯源信息展示样例</h3>
      <p>　</p>
      <div class="exampl d-flex">
        <el-image class="image" :src="require('@/assets/images/as.jpg')"></el-image>
        <div class="exampl-right">
          <div class="list">
            <div class="item d-flex align-center">
              <el-image
                class="image"
                :src="require('@/assets/images/icon_01.png')"
              ></el-image>
              <span>养殖环节</span>
            </div>
            <div class="item d-flex align-center">
              <el-image
                class="image"
                :src="require('@/assets/images/icon_02.png')"
              ></el-image>
              <span>产地检疫</span>
            </div>
            <div class="item d-flex align-center">
              <el-image
                class="image"
                :src="require('@/assets/images/icon_03.png')"
              ></el-image>
              <span>屠宰检疫</span>
            </div>
            <div class="item d-flex align-center">
              <el-image
                class="image"
                :src="require('@/assets/images/icon_04.png')"
              ></el-image>
              <span>肉品检疫</span>
            </div>
            <div class="item d-flex align-center">
              <el-image
                class="image"
                :src="require('@/assets/images/icon_05.png')"
              ></el-image>
              <span>物流运输</span>
            </div>
            <div class="item d-flex align-center">
              <el-image
                class="image"
                :src="require('@/assets/images/icon_06.png')"
              ></el-image>
              <span>销售环节</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.info {
  padding-bottom: 1.25rem;
  &-content {
    padding-top: 1.25rem;
    h3 {
      font-size: 0.375rem;
      margin-bottom: 0.375rem;
    }
    p {
      text-transform: uppercase;
      font-size: 0.2rem;
      color: #666;
      margin-bottom: 1rem;
    }
    .exampl {
      .image {
        display: block;
        width: 5rem;
        height: 7rem;
      }
      &-right {
        position: relative;
        width: 10rem;
        height: 7rem;
        background: #f9fafe url('../../../assets/images/cop.png') no-repeat left center;
        background-size: 9.25rem 6.2875rem;
        .list {
          position: absolute;
          top: 0.625rem;
          right: 0.75rem;
          .item {
            margin-bottom: 0.375rem;
            &:last-of-type {
              margin-bottom: 0;
            }
            .image {
              display: block;
              width: 0.375rem;
              height: 0.375rem;
            }
            span {
              padding-left: 0.125rem;
              font-weight: 600;
              font-size: 0.225rem;
              color: #666;
            }
          }
        }
      }
    }
  }
}
</style>
